import { render } from "./main-area.vue?vue&type=template&id=52530601&scoped=true"
import script from "./main-area.vue?vue&type=script&lang=js"
export * from "./main-area.vue?vue&type=script&lang=js"

import "./main-area.vue?vue&type=style&index=0&id=52530601&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52530601"]])

export default __exports__